module.exports = __webpack_public_path__ + "static/img/bgi.212a606a.png";